import {
  Component,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  OnDestroy,
} from "@angular/core";
import { Route, Router, RouterOutlet } from "@angular/router";
import { slideInAnimation } from "@app/core/const";
import { HttpService, PermissionsService, ProjectService, UserService } from "@app/core/services";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "@env/environment";

import { BreadcrumbModule } from "params-xng-breadcrumb";
import { HttpResponse } from "@angular/common/http";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { ToastrService } from "ngx-toastr";

// import * as ruMessages from 'devextreme/localization/messages/ru.json';

@Component({
  selector: "app-body",
  templateUrl: "./body.component.html",
  styleUrls: ["./body.component.scss"],
  animations: [slideInAnimation],
})
export class BodyComponent implements OnInit, OnDestroy {
  public version = environment.version;
  public menuSizeClass = localStorage.getItem("menuSizeClass") || "big";

  // rus = ruMessages;
  isRequiredPersonalDataOpen: boolean = false;
  loginLoading: boolean = false;
  privacy: any = {
    lastName: null,
    middleName: null,
    firstName: null,
    email: null,
    phone: null,
    privacyOk: false
  };

  constructor(
    private httpService: HttpService,
    private projectService: ProjectService,
    private userService: UserService,
    private translate: TranslateService,
    private ref: ChangeDetectorRef,
    private translateService: TranslateService,
    private toastr: ToastrService,
    private router : Router

  ) // private breadcrumbService :BreadcrumbService

  {
    translate.setDefaultLang("ru");
    // loadMessages(this.rus);
    // locale('ru');
  }

  ngOnInit() {
    this.userService.isRequiredPersonalDataOpen.subscribe((b) => {
      this.isRequiredPersonalDataOpen = b
      if(b) {
        console.log('ngOnInit body',this.router.url)
        if(this.router.url !='/home') this.router.navigate(['/home'])
      }
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onChangeMenuSizeClass(e: string) {
    this.menuSizeClass = e;
    this.ref.detectChanges();
  }

  prepareRoute(outlet: RouterOutlet) {
    return (
      outlet &&
      outlet.activatedRouteData &&
      outlet.activatedRouteData["animation"]
    );
  }

  get contentClass() {
    let mainMenu = document.getElementById("mainMenu");
    return {
      big: mainMenu.classList.contains("big"),
      small: mainMenu.classList.contains("small"),
    };
  }
  private ngUnsubscribe = new Subject();

  checkComparison = () => true;


  onSavePrivasy() {

    let body = {
      lastName: this.privacy.lastName,
      firstName: this.privacy.firstName,
      middleName: this.privacy.middleName,
      email: this.privacy.email,
      phoneNumber: this.privacy.phone,
    };
    this.httpService
      .postResponse("employee-service/api/employee/short", body)
      .subscribe(
        (response: HttpResponse<any>) => {
          if (response.ok) {
            this.translateService
              .get("notification.SUCCESS")
              .pipe(takeUntil(this.ngUnsubscribe))
              .toPromise()
              .then((v) => {
                this.toastr.success(v, "", { timeOut: 2000 });
              });
          }
          // this.isRequiredPersonalDataOpen = false;
          this.userService.isRequiredPersonalData.next(false)
          this.userService.isRequiredPersonalDataOpen.next(false)
        },
        (error: any) => {
          // this.dataGrids.instance.clearSelection();
          // Получаем перевод ошибки при отправке и показываем тостер
          this.translateService
            .get(["notification.FAILURE", "notification.ERROR_CODE"], {
              value: error.status,
            })
            .pipe(takeUntil(this.ngUnsubscribe))
            .toPromise()
            .then((v) => {
              this.toastr.error(
                error.error.message,
                v["notification.ERROR_CODE"],
                {
                  progressBar: false,
                  timeOut: 100000,
                  closeButton: true,
                }
              );
            });
        }
      );
  }
}
